<div class="select-b2b-unit-modal">
  <div class="select-b2b-unit-modal__header">
    <h3 class="select-b2b-unit-modal__title">{{ 'selectB2BUnitModal.title' | translate }}</h3>
  </div>

  <div class="select-b2b-unit-modal__body">
    <!-- Search Field -->
    <div class="select-b2b-unit-modal__search">
      <label for="b2b-unit-search" class="visually-hidden">
        {{ 'selectB2BUnitModal.searchPlaceholder' | translate }}
      </label>
      <input
        id="b2b-unit-search"
        type="text"
        class="form-control"
        [placeholder]="'selectB2BUnitModal.searchPlaceholder' | translate"
        [(ngModel)]="searchTerm"
        (keydown.enter)="onSearch()"
        [attr.aria-label]="'selectB2BUnitModal.searchPlaceholder' | translate"
      />
      <button type="button" class="select-b2b-unit-modal__search-btn" (click)="onSearch()" [disabled]="isLoading">
        <span class="material-symbols-outlined">search</span>
      </button>
    </div>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="select-b2b-unit-modal__loading">
        <p>{{ 'selectB2BUnitModal.loading' | translate }}</p>
      </div>
    }

    <!-- B2B Units List -->
    @if (!isLoading && filteredB2BUnits.length > 0) {
      <div class="select-b2b-unit-modal__list">
        @for (unit of filteredB2BUnits; track unit.id) {
          <div
            class="b2b-unit-item"
            [class.b2b-unit-item--selected]="selectedB2BUnit?.id === unit.id"
            (click)="selectB2BUnit(unit)"
            (keydown.enter)="selectB2BUnit(unit)"
            (keydown.space)="selectB2BUnit(unit)"
            tabindex="0"
            role="button"
            [attr.aria-pressed]="selectedB2BUnit?.id === unit.id"
          >
            <div class="b2b-unit-item__info">
              <!-- <h4 class="b2b-unit-item__name">{{ unit.name }}</h4> -->
              <p class="b2b-unit-item__details">{{ unit.name }} - {{ unit.uid }}</p>
            </div>
            @if (selectedB2BUnit?.id === unit.id) {
              <span class="material-symbols-outlined b2b-unit-item__check">check_circle</span>
            }
          </div>
        }
      </div>
    }

    <!-- No Results -->
    @if (!isLoading && filteredB2BUnits.length === 0) {
      <div class="select-b2b-unit-modal__empty">
        <p>{{ 'selectB2BUnitModal.noResults' | translate }}</p>
      </div>
    }
  </div>

  <div class="select-b2b-unit-modal__footer">
    <button type="button" class="btn btn-primary" [disabled]="!selectedB2BUnit" (click)="confirmSelection()">
      {{ 'selectB2BUnitModal.confirmSelection' | translate }}
    </button>
  </div>
</div>
